import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import Speaker from '@gamiphy/icons/Speaker';

const ReferralCampaignHeader: React.FC = () => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box minWidth={35}>
        <Speaker color={theme.palette.primary.main} />
      </Box>
      <Typography fontSize={16} fontWeight={700}>
        <Trans
          i18nKey="campaigns.boosters.referral.refer"
          defaults="Refer a friend"
        />
      </Typography>
    </Box>
  );
};

export default ReferralCampaignHeader;
